import(/* webpackMode: "eager", webpackExports: ["TranslationsProvider"] */ "/app/src/lib/i18n/TranslationsProvider.tsx");
